<template>
  <tab-manager 
    title="Completed" 
    :visit-type="visitType" 
    :participants="participants"
  >
    <template #columns="{ toggleSort, sortKey, sortDir }">
      <th scope="col" class="py-3 user-select-none style-pointer" @click="toggleSort('star_id')">
        STAR ID
        <i class="bi ms-1" :class="getSortIcon('star_id', sortKey, sortDir)"></i>
      </th>

      <th scope="col" class="py-3 user-select-none style-pointer" @click="toggleSort('name')">
        Participant
        <i class="bi ms-1" :class="getSortIcon('name', sortKey, sortDir)"></i>
      </th>

      <th scope="col" class="py-3 user-select-none style-pointer" @click="toggleSort('targetMonth')">
        Target Visit Month
        <i class="bi ms-1" :class="getSortIcon('targetMonth', sortKey, sortDir)"></i>
      </th>

      <th scope="col" class="py-3 user-select-none style-pointer" @click="toggleSort('date')">
        Completed Visit Date
        <i class="bi ms-1" :class="getSortIcon('date', sortKey, sortDir)"></i>
      </th>
    </template>

    <template #rows="{ participants: filteredList }">
      <tr v-for="participant in filteredList" :key="participant.id">
        <td class="fw-bold">{{ participant.star_id }}</td>
        <td>
          <a :href="`/participants/${participant.id}`">
            {{ participant.first_name }} {{ participant.last_name }}
          </a>
        </td>
        <td>{{ participant.targetMonth }}</td>
        <td>{{ participant.tasks[0]?.appointments[0]?.starts_at }}</td>
      </tr>
    </template>
  </tab-manager>
</template>

<script setup>
import TabManager from './TabManager.vue';

defineProps({
  participants: { type: Array, default: () => [] },
  visitType: { type: String, default: 'Core' }
});

const getSortIcon = (columnKey, activeKey, activeDir) => {
  if (columnKey !== activeKey) return 'bi-arrow-down-up text-muted opacity-50';
  return activeDir === 'asc' ? 'bi-arrow-up text-primary' : 'bi-arrow-down text-primary';
};
</script>

<style scoped>
.style-pointer {
  cursor: pointer;
}
</style>